  $(document).ready(function() {

      $(".btndivALLxz").on("click", function() {
          $("#AddressNewForm").toggle("hidden");
      });

      $(".btnSideAVR").on("click", function() {
          $(".EditAddressRead").toggle("hidden");
      });

      $(".account-sidebar a").on("click", function(e) {
          if ($(this).attr('id') == 'customer_logout_link') {} else {
              e.preventDefault();
          }
          var dataAttr = $(this).attr('href');
          $(dataAttr).addClass('active').siblings().removeClass('active');
      });

      const deleteButtons = document.querySelectorAll('.address-delete');
      if (deleteButtons.length) {
          deleteButtons.forEach((element) => {
              element.addEventListener('click', function() {
                  const formId = this.dataset.formId;
                  const confirmMessage = this.dataset.confirmMessage;
                  if (confirm(confirmMessage)) {
                      Shopify.postLink(window.theme.routes.addresses_url + '/' + formId, {
                          parameters: {
                              _method: 'delete'
                          }
                      });
                  }
              });
          });
      }

      // Get all <li> elements
      const listItems = document.querySelectorAll('ul li');

      // Add click event listener to each <li>
      listItems.forEach(item => {
          item.addEventListener('click', function() {
              // Find the closest <details> ancestor and remove the 'open' attribute
              const details = this.closest('details');
              if (details) {
                  details.removeAttribute('open');
              }
          });
      });
  });